/**
 * Custom hook providing info on environment where the app is running. Dev vs production, etc.
 * @return {{}} { isDevEnv = true, if app is running in development environment }
 */
export function useEnvironment() {
  const isDevEnv = window.location.href.includes('localhost');

  return {isDevEnv} as const;
}
